import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import SimpleBoxDisplay from "../../../common/SimpleBoxDisplay"
import InputBoxCurrency from "../../../common/interactive/InputBoxCurrency"
import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel"
import { getLiabilityPolicyLimitsLabel } from "../../../../lib/labels"
import { returnPrimaryInsuranceOrTheNextActiveOne } from "../../../../lib/primaryItemScripts"
import Grid from "../../../fragments/Grid"
import TagImproved from "../../../fragments/TagImproved"
import { getColorCodeFromSystemSettings, getColorFromSystemSettings, getLabelFromSystemSettings } from "../../../../lib/script"
import Tag from "../../../fragments/Tag"
import { frontendOptions } from "../../../../lib/systemData"

import classes from './NegotiationRow.module.css'
import InputBoxCurrencyAlternative from "../../../common/interactive/InputBoxCurrencyAlternative"

export default function NegotiationLiability({updateHandler}) {
    const activeCase = useSelector(state => state.case.activeCase) 

    const [liabilityData, setLiabilityData] = useState(null)

    useEffect(() => {
        
        if (activeCase && activeCase.liabilities) {

            let primary = returnPrimaryInsuranceOrTheNextActiveOne(activeCase, 'liabilities')

            if (primary) {
                setLiabilityData(primary)
            }
            
            
        }
    }, [activeCase])
    
console.log('liabilityData.liability_status:::: ', liabilityData?.liability_status)
    return <div className={classes.container}>
        <div className={`${classes.row} ${classes.row_header}`}>
            <h3>Liability</h3>
            {liabilityData &&<div className={`${classes.header_side}`}>
                {liabilityData.liability_status !== null ? 
                <TagImproved color={getColorFromSystemSettings(frontendOptions()?.assumedOptions, liabilityData.liability_status)} colorCode={getColorCodeFromSystemSettings(frontendOptions()?.assumedOptions, liabilityData.liability_status)}>
                    {getLabelFromSystemSettings(frontendOptions()?.assumedOptions, liabilityData.liability_status)}
                </TagImproved> 
                : 
                ''}

                {liabilityData.commercial_policy ? <Tag color={'Grey'}>Commercial</Tag> : ''}
            </div>}
        </div>
        {liabilityData && <>
            <div className={classes.row}>
                <SimpleBoxDisplay label={'Insurance company'} value={liabilityData.insurance_carrier?.name}/>
            </div>
            <div className={`${classes.row} ${classes.row_flex}`}>
                <SimpleBoxDisplay label={'Liability Limit Patient'} value={getLiabilityPolicyLimitsLabel(liabilityData.policy_limit_patient)}/>
                <SimpleBoxDisplay label={'Liability Limit Accident'} value={getLiabilityPolicyLimitsLabel(liabilityData.policy_limit_accident)}/>
            </div>
            <div className={`${classes.row} ${classes.row_flex}`}>
                {/* special={'negotiation_grid'} */}
                <Grid columns={2} gap={8} > 
                    <DatepickerWithLabel action={updateHandler} label={'Negotiation Date '} defaultDate={activeCase?.case_negotiation?.liability_negotiation_date} identifier={{type: 'case_negotiation', field: 'liability_negotiation_date', type_id: null, folder: 'case_negotiation'}}/>
                    <DatepickerWithLabel action={updateHandler} label={'Case Settlement Date'} defaultDate={activeCase.case_negotiation?.liability_case_settlement_date} identifier={{type: 'case_negotiation', field: 'liability_case_settlement_date', type_id: null, folder: 'case_negotiation'}}/>
                </Grid>
            </div>
            <div className={classes.row}>
                <InputBoxCurrencyAlternative action={updateHandler} label={'Liability Top Offer'} currentValue={activeCase.case_negotiation?.liability_case_top_offer_from_insurance} identifier={{type: 'case_negotiation', field: 'liability_case_top_offer_from_insurance', type_id: null, folder: 'case_negotiation'}}/>
            </div>
        </>}   
    </div>
}